import { useTranslation } from 'react-i18next';
import starSVG from '../../../../../assets/images/svgs/star.svg';
import assignSVG from '../../../../../assets/images/svgs/calendar.svg';
import rec1 from '../../../../../assets/images/recomendation/rec1.jpeg';
import Button from '../../../../../components/primitives/button';

export const StudentMentorsList = () => {
  const { t } = useTranslation();

  return (
    <div className="student-wrapper my-mentors-wrapper">
      <h3 className="student-wrapper-title">{t('mentors.title')}</h3>

      <ul className="my-mentors-wrapper__list">
        <li className="my-mentors-wrapper__list-item">
          <div className="my-mentors-wrapper__list-item-FIO">
            <img src={rec1} alt="" />
            <div className="FIO">
              <span>Audrey</span>
              <span>Edwards</span>
            </div>
          </div>

          <div className="my-mentors-wrapper__list-item-info">
            <span className="my-mentors-wrapper__list-item-info-status">
              Professional teacher
            </span>
            <div className="my-mentors-wrapper__list-item-info-rate">
              <img src={starSVG} alt="" />
              <span>4.5</span>
            </div>
            <Button
              onClick={() => {}}
              className="black-btn assign-btn"
              iconSvg={<img src={assignSVG} alt="" />}
              iconSvgClass="left-btn-icon"
              title={t('btn.assign')}
              titleClassName="swlc-16-700-24-white"
              buttonHeight="48px"
            />
          </div>
        </li>
        <li className="my-mentors-wrapper__list-item">
          <div className="my-mentors-wrapper__list-item-FIO">
            <img src={rec1} alt="" />
            <div className="FIO">
              <span>Audrey</span>
              <span>Edwards</span>
            </div>
          </div>

          <div className="my-mentors-wrapper__list-item-info">
            <span className="my-mentors-wrapper__list-item-info-status">
              Professional teacher
            </span>
            <div className="my-mentors-wrapper__list-item-info-rate">
              <img src={starSVG} alt="" />
              <span>4.5</span>
            </div>
            <Button
              onClick={() => {}}
              className="black-btn assign-btn"
              iconSvg={<img src={assignSVG} alt="" />}
              iconSvgClass="left-btn-icon"
              title={t('btn.assign')}
              titleClassName="swlc-16-700-24-white"
              buttonHeight="48px"
            />
          </div>
        </li>
        <li className="my-mentors-wrapper__list-item">
          <div className="my-mentors-wrapper__list-item-FIO">
            <img src={rec1} alt="" />
            <div className="FIO">
              <span>Audrey</span>
              <span>Edwards</span>
            </div>
          </div>

          <div className="my-mentors-wrapper__list-item-info">
            <span className="my-mentors-wrapper__list-item-info-status">
              Professional teacher
            </span>
            <div className="my-mentors-wrapper__list-item-info-rate">
              <img src={starSVG} alt="" />
              <span>4.5</span>
            </div>
            <Button
              onClick={() => {}}
              className="black-btn assign-btn"
              iconSvg={<img src={assignSVG} alt="" />}
              iconSvgClass="left-btn-icon"
              title={t('btn.assign')}
              titleClassName="swlc-16-700-24-white"
              buttonHeight="48px"
            />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default StudentMentorsList;
